document.addEventListener("DOMContentLoaded", function() {
    const videoSection = document.querySelector(".video-section");
    const video = videoSection.querySelector("iframe");
    const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
        video.src = video.src + "&autoplay=1";
        } else {
        video.src = video.src.replace("&autoplay=1", "");
        }
    });
    });
    observer.observe(videoSection);
});